import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { applyColorTheme, updateColorThemeOnServer } from '@redpanda/utils';

export type ColorTheme = 'blue' | 'violet' | 'emerald' | 'teal' | 'amber' | 'zinc';

interface ColorThemeContextType {
  colorTheme: ColorTheme;
  setColorTheme: (theme: ColorTheme) => void;
  /** 登入後套用伺服器上的配色（不寫回伺服器；使用者自己換配色才用 setColorTheme） */
  applyServerColorTheme: (theme: ColorTheme) => void;
}

const ColorThemeContext = createContext<ColorThemeContextType | undefined>(undefined);

const STORAGE_KEY = 'account-portal-color-theme';
const IDENTITY_SERVICE_URL = process.env.REACT_APP_IDENTITY_SERVICE_URL || 'http://localhost:3000';

export const ColorThemeProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [colorTheme, setColorThemeState] = useState<ColorTheme>(() => {
    return (localStorage.getItem(STORAGE_KEY) as ColorTheme) || 'blue';
  });

  const setColorTheme = (theme: ColorTheme) => {
    setColorThemeState(theme);
    applyColorTheme(theme);
    updateColorThemeOnServer(theme, IDENTITY_SERVICE_URL);
  };
  const applyServerColorTheme = (theme: ColorTheme) => {
    setColorThemeState(theme);
    applyColorTheme(theme);
  };


  useEffect(() => {
    applyColorTheme(colorTheme);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <ColorThemeContext.Provider value={{ colorTheme, setColorTheme, applyServerColorTheme }}>
      {children}
    </ColorThemeContext.Provider>
  );
};

export const useColorTheme = (): ColorThemeContextType => {
  const ctx = useContext(ColorThemeContext);
  if (!ctx) throw new Error('useColorTheme must be used within ColorThemeProvider');
  return ctx;
};
